import { useContext } from 'react';
import { WizardDrawerContext } from '../constants/wizard-drawer';

export const useWizardDrawer = () => useContext(WizardDrawerContext);
